window.addEventListener('load', function(){
    // All resources finished loading!
    document.querySelector('body').classList.add('loaded');
});


// WEBPACK FOOTER //
// ./resources/js/components/loader.js